<script lang="ts">
  import type {User} from '../types'
  import {replaceValues, t} from '../i18n'

  export let user: User
</script>

<div class="writer__item">
  <a class="writer__photo" href={user.link}>
    <img src={user.avatar_big_thumgb} alt={user.full_name}/>
  </a>
  <div class="writer__name">
    <a href={user.link}>{user.full_name}</a>
    <small class="italic poem-count">
      {replaceValues(t.author.n_poems, {n: user.poems_count})}
    </small>
  </div>
</div>
